/*
 *
 * ExpiredSessionModal
 *
 * @version 1.0.0
 * @author Pietro Bertuccelli
 * @since 24-Sep-2025
*/

import { connect } from 'react-redux'
// import { bindActionCreators } from 'redux'
import { doHidePopup } from 'Store/actions/popup'
import ExpiredSessionModal from './ExpiredSessionModal'

const mapDispatchToProps = (dispatch) => ({
  hidePopup: () => dispatch(doHidePopup())
})

const mapStateToProps = () => ({

})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(ExpiredSessionModal)
